var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGreenFolder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#green_folder_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#green_folder_svg__b)",
  d: "M0 0h36v36H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#green_folder_svg__c)",
  d: "M0 0h36v36H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#090C0F",
  fillOpacity: 0.05,
  d: "M0 0h36v36H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.833 13.833-.93-1.859c-.267-.535-.401-.803-.6-.998a1.665 1.665 0 0 0-.624-.385c-.264-.091-.563-.091-1.161-.091h-3.185c-.934 0-1.4 0-1.757.182-.314.16-.569.414-.728.728-.182.357-.182.823-.182 1.757v.666m0 0h12.667c1.4 0 2.1 0 2.635.273a2.5 2.5 0 0 1 1.092 1.092c.273.535.273 1.235.273 2.635V21.5c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.092c-.535.273-1.235.273-2.635.273h-8.667c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.093-1.092c-.272-.535-.272-1.235-.272-2.635v-7.667Z",
  stroke: "#F9F9F9",
  strokeWidth: 1.667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 35,
  height: 35,
  rx: 17.5,
  stroke: "#fff",
  strokeOpacity: 0.15
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "green_folder_svg__b",
  x1: 18,
  y1: 0,
  x2: 18,
  y2: 36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75EA77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2A642C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "green_folder_svg__c",
  x1: 18,
  y1: 0,
  x2: 18,
  y2: 36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75EA77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2A642C"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "green_folder_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("image", {
  id: "green_folder_svg__d",
  width: 64,
  height: 64,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAONJREFUeF7t20EOhEAIRFG4/6F7DvEnYeFzryQIv6pBd2behOu9dPvsbog+k+NLgArQAqmJcw9iAAhSgZKB3IJkkAySQTJ4CiE+gA8oBeg0mH3Ai084P89HhqwEqIA209ICsQdjAeaZIgaAYKxBDMCAYy8fXwAIgiAIcoJpJEYGI4VjB3YrbC9gL2AvkCB43cM5PgZgAAZgQFnNZAhdGykQBEEQBEEQDBmgAm2glM/z+QUYisYUGoldO7kY32IEAzCg6RgIRgjFAsw+AgRBMNYgBmCAT2TCYfoPPz/HCqQCX1eBHzHnv7C7WhBSAAAAAElFTkSuQmCC"
}))));
export default SvgGreenFolder;